"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/styles");

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));

exports.StyledButton = styles_1.styled(Button_1.default)({
  // Ikitsuke-clinc 側で style が上書きされてしまっているので specificity をあげて対応
  '&[class]': {
    backgroundColor: 'var(--color-grey-light-1)',
    color: 'var(--color-grey-dark-2)',
    border: "1px solid var(--color-grey-dark-2)",
    fontSize: 'var(--font-size-medium)',
    padding: '.75rem 1rem',
    boxShadow: "var(--box-shadow-default)",
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: 'var(--color-grey-light-4)'
    }
  }
});
exports.StyledMenuItem = styles_1.styled(MenuItem_1.default)({
  fontSize: 'var(--font-size-medium)'
});